import React, { memo } from 'react';

const WarningRoundInner = () => (
    <svg viewBox="0 0 24 24">
        <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM11 14V6H13V14H11ZM11 18V16H13V18H11Z" />
    </svg>
);

export const WarningRound = memo(WarningRoundInner);
